export default "__VITE_ASSET__C0fryd4f__"